if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.loadModalImages();
      }

      loadModalImages() {
        const images = Array.from(this.querySelectorAll('img[data-product-modal-src]'));
        const activeId = this.openedBy && this.openedBy.getAttribute('data-media-id');
        const activeImage = activeId && this.querySelector(`img[data-media-id="${activeId}"]`);
        const activeIndex = images.indexOf(activeImage);

        if (activeIndex >= 0) {
          images.slice(Math.max(0, activeIndex - 1), activeIndex + 2).forEach((image) => {
            this.hydrateModalImage(image);
          });
        } else if (images[0]) {
          this.hydrateModalImage(images[0]);
        }

        const modalContent = this.querySelector('[role="document"]');
        if (!modalContent || this.modalImageScrollBound) return;
        this.modalImageScrollBound = true;
        let ticking = false;

        modalContent.addEventListener('scroll', () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            this.loadNearestModalImages(modalContent);
            ticking = false;
          });
        }, { passive: true });
      }

      loadNearestModalImages(modalContent) {
        const rootRect = modalContent.getBoundingClientRect();
        const center = rootRect.top + rootRect.height / 2;
        Array.from(this.querySelectorAll('img[data-product-modal-src]'))
          .sort((first, second) => {
            return Math.abs(first.getBoundingClientRect().top - center) - Math.abs(second.getBoundingClientRect().top - center);
          })
          .slice(0, 3)
          .forEach((image) => this.hydrateModalImage(image));
      }

      hydrateModalImage(image) {
        if (!image || !image.dataset.productModalSrc) return;
        image.addEventListener('load', () => image.classList.remove('product-modal-lazy-image'), { once: true });
        if (image.dataset.productModalSrcset) image.srcset = image.dataset.productModalSrcset;
        image.src = image.dataset.productModalSrc;
        image.removeAttribute('data-product-modal-srcset');
        image.removeAttribute('data-product-modal-src');
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
